


















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AchievementRow extends Vue {
  @Prop() private stats!: Record<string, number>;
  @Prop() private name!: string;
  @Prop() private amts!: number[];
  @Prop() private statKey!: string;

  get earned () {
    return this.stats[this.statKey]
  }
}
